import "./details-section.scss";
import { IProps } from "./details-section.types";

/**
 * Section of miscellaneous details provided by the backend.
 * @param props.children Contents of the section.
 * @returns              Section component.
 */
const DetailsSection = ({ children }: IProps) => <section className="details-section">{children}</section>;

export default DetailsSection;
